import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Modal,
  Form,
  Container,
  Badge,
  ButtonGroup,
} from "react-bootstrap";
import axios from "axios";
import moment from 'moment'

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Toast } from "primereact/toast";

import "../../asset/style.css";

import { APIKEY } from "../../Config/Config";


class CertificationEnquiry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enquiries: [],
      showAdd: false,
      show: false,
      filters: null,
      globalFilterValue: "",
      loading: true,
    };
      this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);

  }

  componentDidMount() {
    this.fetchEnquiries();
  }

  fetchEnquiries() {
    axios.get(`${APIKEY}/certification-enquiry`).then((res) => {
      const enquiries = res.data;
      this.setState({
        enquiries: enquiries,
        loading: false,
      });
    }).catch(error => {
      console.error('Error fetching enquiries:', error);
      this.setState({
        loading: false,
      });
    });
  }


  leftToolbarTemplate() {
    return (
      <React.Fragment>
        {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={this.confirmDeleteSelected} disabled={!this.state.selectedProducts || !this.state.selectedProducts.length} /> */}
        <div>
          <h3>Certification Enquiry List</h3>
        </div>
      </React.Fragment>
    );
  }


  renderHeader() {
    return (
      <div className="flex justify-content-between">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={this.state.globalFilterValue}
            onChange={(e) => this.setState({ globalFilterValue: e.target.value })}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  }

  render() {
    const header = this.renderHeader();

    return (

      <Container fluid>
        <Toast ref={(el) => (this.toast = el)} />

        <div>
            <Toolbar
              className="mb-4"
              left={this.leftToolbarTemplate}
            ></Toolbar>
          <DataTable
            value={this.state.enquiries}
            ref={(el) => (this.dt = el)}
            paginator
            scrollable
            scrollHeight="400px"
            className="p-datatable-customers"
            showGridlines
            rows={10}
            dataKey="_id"
            filters={this.state.filters}
            filterDisplay="menu"
            loading={this.state.loading}
            responsiveLayout="scroll"
            globalFilter={this.state.globalFilterValue}
            header={header}
            emptyMessage="No enquiries found."
          >
            <Column
              field="name"
              header="Name"
              sortable
              style={{ minWidth: "250px" }}
            />
            <Column
              field="number"
              header="Contact Number"
              sortable
              style={{ minWidth: "250px" }}
            />
	    <Column
              field="company_name"
              header="Company Name"
              sortable
              style={{ minWidth: "250px" }}
            />
            <Column
              field="email"
              header="Company Email"
              sortable
              style={{ minWidth: "250px" }}
            />
            <Column
              field="created"
              header="Enquiry Date"
              style={{ minWidth: "150px" }}
            />
          </DataTable>
        </div>
      </Container>
    );
  }
}

export default CertificationEnquiry;

